export const route = state => {
  return state.route
}
export const routePath = state => {
  return state.route.path
}



// WEBPACK FOOTER //
// ./src/store/getters.js